import { render, staticRenderFns } from "./selectFile.vue?vue&type=template&id=48ca49d6&scoped=true&"
import script from "./selectFile.vue?vue&type=script&lang=js&"
export * from "./selectFile.vue?vue&type=script&lang=js&"
import style0 from "./selectFile.vue?vue&type=style&index=0&id=48ca49d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ca49d6",
  null
  
)

export default component.exports